module.exports = __webpack_public_path__ + "img/close_white_icon.17d5f2e5.svg";